<addiction-input [value]="nameToSave | translate" (valueChange)="saveName($event)"></addiction-input>

<div class="button-container">
	<button *ngIf="nameToSave" (click)="close()">
    <span>{{ 'ADD' | translate }}</span>
  </button>
</div>
